module.exports = __webpack_public_path__ + "static/media/International Customers 2.dffb1963.webp";